"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
//# sourceMappingURL=envelopes.js.map